// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_sectionContainer__x5iEO {
  -webkit-user-select: none;
          user-select: none;
  margin-top: 0.5rem;
  margin-right: 50px;
}

.home_sectionContainer__x5iEO:nth-child(2) {
  margin-right: 0;
}

.home_sectionTitle__YpW1I {
  display: flex;
  justify-content: space-between;
  text-align: left;
  align-items: center;
}

.home_sectionTitle__YpW1I div:last-child {
  color: var(--global-main-color);
  font-weight: 500;
  display: flex;
  flex-direction: row;
  font-size: medium;
}

.home_sectionImage__N9tOh img,
.home_mainSectionImage__Khqly img {
  border-radius: 15px;
  width: 400px;
  height: 160px;
  box-shadow: #6b728c 0 0 5px;
  cursor: pointer;
  object-fit: cover;
}

.home_deliveryFooter__\\+9oSN {
  display: flex;
}

@media (max-width: 990px) {
  .home_sectionContainer__x5iEO {
    -webkit-user-select: none;
            user-select: none;
    flex-basis: 100%;
    margin-right: 0 !important;
  }
}

.home_billerItem__dX9o1 {
  padding: 0 10px 0 10px;
}

.home_billerContainer__EdZs5 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.home_billerInnerContainer__TfbdF {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  max-width: 100%;
}

.home_seeAll__nXdur {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0 0 10px;
  color: var(--global-main-color);
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.home_halfContainer__iPqIA {
  flex-basis: 50%;
  height: 600px;
  margin-right: 5%;
}

.home_halfContainer__iPqIA:last-child {
  flex-basis: 45%;
  margin-right: 0;
}

.home_responsiveContainer__7uVTN {
  margin-right: 3rem;
  margin-left: 3rem;
  margin-top: 1.5rem;
}

.home_webMargin__7LoH2 {
  margin-right: 3rem;
  margin-left: 3rem;
}

.home_quarterContainer__9AW4Z {
  flex-basis: 24%;
}

.home_mapResponsive__UTtF3 {
  width: 100%;
  height: 475px;
  position: relative;
}

@media (max-width: 650px) {
  .home_mapResponsive__UTtF3 {
    width: 100%;
    height: 340px;
    position: relative;
  }

  .home_hideMobile__MCONk {
    display: none;
  }

  .home_halfContainer__iPqIA,
  .home_halfContainer__iPqIA:last-child {
    flex-basis: 100%;
    height: 360px;
    margin-right: 0;
  }

  .home_quarterContainer__9AW4Z {
    flex-basis: 100%;
    margin-bottom: 1rem;
  }

  .home_responsiveContainer__7uVTN {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    margin-top: 0;
  }

  .home_webMargin__7LoH2 {
    margin-right: 0;
    margin-left: 0;
  }

  .home_sectionImage__N9tOh img {
    width: 250px !important;
    height: 110px !important;
  }

  .home_mainSectionImage__Khqly img {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shop/home/home.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".sectionContainer {\n  user-select: none;\n  margin-top: 0.5rem;\n  margin-right: 50px;\n}\n\n.sectionContainer:nth-child(2) {\n  margin-right: 0;\n}\n\n.sectionTitle {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n  align-items: center;\n}\n\n.sectionTitle div:last-child {\n  color: var(--global-main-color);\n  font-weight: 500;\n  display: flex;\n  flex-direction: row;\n  font-size: medium;\n}\n\n.sectionImage img,\n.mainSectionImage img {\n  border-radius: 15px;\n  width: 400px;\n  height: 160px;\n  box-shadow: #6b728c 0 0 5px;\n  cursor: pointer;\n  object-fit: cover;\n}\n\n.deliveryFooter {\n  display: flex;\n}\n\n@media (max-width: 990px) {\n  .sectionContainer {\n    user-select: none;\n    flex-basis: 100%;\n    margin-right: 0 !important;\n  }\n}\n\n.billerItem {\n  padding: 0 10px 0 10px;\n}\n\n.billerContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.billerInnerContainer {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.seeAll {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 10px 0 0 10px;\n  color: var(--global-main-color);\n  font-weight: 500;\n  user-select: none;\n  cursor: pointer;\n}\n\n.halfContainer {\n  flex-basis: 50%;\n  height: 600px;\n  margin-right: 5%;\n}\n\n.halfContainer:last-child {\n  flex-basis: 45%;\n  margin-right: 0;\n}\n\n.responsiveContainer {\n  margin-right: 3rem;\n  margin-left: 3rem;\n  margin-top: 1.5rem;\n}\n\n.webMargin {\n  margin-right: 3rem;\n  margin-left: 3rem;\n}\n\n.quarterContainer {\n  flex-basis: 24%;\n}\n\n.mapResponsive {\n  width: 100%;\n  height: 475px;\n  position: relative;\n}\n\n@media (max-width: 650px) {\n  .mapResponsive {\n    width: 100%;\n    height: 340px;\n    position: relative;\n  }\n\n  .hideMobile {\n    display: none;\n  }\n\n  .halfContainer,\n  .halfContainer:last-child {\n    flex-basis: 100%;\n    height: 360px;\n    margin-right: 0;\n  }\n\n  .quarterContainer {\n    flex-basis: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .responsiveContainer {\n    margin-right: 0.5rem;\n    margin-left: 0.5rem;\n    margin-top: 0;\n  }\n\n  .webMargin {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .sectionImage img {\n    width: 250px !important;\n    height: 110px !important;\n  }\n\n  .mainSectionImage img {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionContainer": `home_sectionContainer__x5iEO`,
	"sectionTitle": `home_sectionTitle__YpW1I`,
	"sectionImage": `home_sectionImage__N9tOh`,
	"mainSectionImage": `home_mainSectionImage__Khqly`,
	"deliveryFooter": `home_deliveryFooter__+9oSN`,
	"billerItem": `home_billerItem__dX9o1`,
	"billerContainer": `home_billerContainer__EdZs5`,
	"billerInnerContainer": `home_billerInnerContainer__TfbdF`,
	"seeAll": `home_seeAll__nXdur`,
	"halfContainer": `home_halfContainer__iPqIA`,
	"responsiveContainer": `home_responsiveContainer__7uVTN`,
	"webMargin": `home_webMargin__7LoH2`,
	"quarterContainer": `home_quarterContainer__9AW4Z`,
	"mapResponsive": `home_mapResponsive__UTtF3`,
	"hideMobile": `home_hideMobile__MCONk`
};
export default ___CSS_LOADER_EXPORT___;
